const axios = require('axios').default;


async function Telegram(token , id , message ) {
    try {
      const response = await axios.get(`https://api.telegram.org/bot${token}/sendMessage?chat_id=${id}&text=${message}&parse_mode=Markdown`);
      console.log(response);
      console.log('ok')
    } catch (error) {
      console.error(error);
      console.log('error')
    }
}

export default Telegram